import React from 'react';
import { useSelector } from 'react-redux';
import Skeleton from 'react-loading-skeleton';
import { Container } from './styles';
import BilledOrdersFilters from '../../BilledOrdersFilters';
import BilledOrdersTable from '../Tables/BilledOrdersTable';
import { ApplicationState } from '../../../../../store';
import {
  EOrderTab,
  ILongSteelOrderData,
  IBilledOrderData
} from '../../../../../store/ducks/long-steel-orders/types';
import {
  ECustomerTypeView,
  IUserPreference,
  IUserOrderItemPreference,
  EUserPreferenceType
} from '../../../../../store/ducks/user/types';

interface IBilledOrdersProps {
  loading: boolean;
  isStateZero: boolean;
  selectedTab?: EOrderTab;
  orderTab?: EOrderTab;
  customerViewType: ECustomerTypeView;
  filteredOrders: ILongSteelOrderData[];
  setFilteredOrders(filteredOrders: ILongSteelOrderData[]): void;
  onCleanFilters(): void;
  loadOrders(
    states: string[],
    emitterIds: string[],
    startDate?: string,
    endDate?: string
  ): void;
  receiverBilledId: string;
  setReceiverBilledId(receiverId: string): void;
  emitterIds: string[];
  setEmitterIds(emitterIds: string[]): void;
}

const defaultOrderUserPreference: IUserPreference = {
  name: EUserPreferenceType.ORDERS,
  ordersItens: {
    idOrder: '0',
    idProduct: '0'
  }
};

const BilledOrders: React.FC<IBilledOrdersProps> = ({
  loading,
  selectedTab,
  orderTab,
  customerViewType,
  filteredOrders,
  setFilteredOrders,
  onCleanFilters,
  loadOrders,
  receiverBilledId,
  setReceiverBilledId,
  emitterIds,
  setEmitterIds
}) => {
  const ordersState = useSelector(
    (state: ApplicationState) => state.longSteelOrders
  );

  const orderUserPreference =
    useSelector(
      (state: ApplicationState) =>
        state.user.preferences.find(
          (pref) => pref.name === 'orders'
        ) as IUserPreference
    ) || defaultOrderUserPreference;

  return (
    <Container>
      <div>
        {ordersState.items.length > 0 && (
          <BilledOrdersFilters
            orderState={ordersState}
            customerViewType={customerViewType}
            orderTab={orderTab}
            onCleanFilters={onCleanFilters}
            loadOrders={loadOrders}
            isFiltered={filteredOrders.length !== ordersState.items.length}
            setFilteredOrders={setFilteredOrders}
            receiverBilledId={receiverBilledId}
            setReceiverBilledId={setReceiverBilledId}
            emitterIds={emitterIds}
            setEmitterIds={setEmitterIds}
          />
        )}

        {(loading || !selectedTab) && (
          <>
            <Skeleton count={5} width={'16%'} style={{ margin: '1rem 2%' }} />
            <Skeleton count={5} width={'96%'} style={{ margin: '0.5rem 2%' }} />
          </>
        )}

        {!loading &&
          orderUserPreference &&
          selectedTab === EOrderTab.BILLED && (
            <BilledOrdersTable
              filteredOrders={filteredOrders as IBilledOrderData[]}
              userOrderPreference={
                orderUserPreference.ordersItens as IUserOrderItemPreference
              }
              customerViewType={customerViewType}
            />
          )}
      </div>
    </Container>
  );
};

export default BilledOrders;
